import React from "react";
import { useLocation } from "react-router-dom";
import LegacyLeaderboardPage from "./LeaderboardPage";
import V2LeaderboardPage from "./LeaderboardPage.jsx";
import { isLeaderboardV2Path } from "../../universal/v2Routes";

export default function LeaderboardPageByRoute(props) {
    const location = useLocation();
    const LeaderboardPageComponent = isLeaderboardV2Path(location.pathname)
        ? V2LeaderboardPage
        : LegacyLeaderboardPage;
    return <LeaderboardPageComponent {...props} />;
}

